import { type ReactElement } from "react";

import { RolePermissions } from "../../../../../../../../enums";
import { getAssetsMultiStateOptions } from "./assetsOptions";
import { communicationsOptions } from "./communicationOptions";

import { type MultiStateDropdownOption } from "components/dropdowns/multiStateDropdown/MultiStateDropdown";
import { type CardsViewerItem } from "../../../../../../../../components/cardsViewer/types";
import DesignerAssetCard from "components/cards/DesignerAssetCard/DesignerAssetCard";
import StaticAssetCard from "../../../dragndropCards/StaticAssetCard";
import { ExtrasCard } from "../../Extras";
import { EntityType } from "features/Library/Flows/Designer/types";

interface TabsOptions {
  label: string;
  id: string;
  permissions: RolePermissions[];
  filterOptions?: MultiStateDropdownOption<string>[];
  renderCard: (isReadOnly: boolean) => (props: CardsViewerItem<any>) => ReactElement;
}

export const getContentViewTabsOptions = (
  linkAssetTypeEnabled: boolean = false,
  scormEnabled: boolean = false,
): TabsOptions[] => [
  {
    label: "Assets",
    id: "flow-designer-assets-filter",
    permissions: [RolePermissions.AssetsView],
    filterOptions: getAssetsMultiStateOptions(linkAssetTypeEnabled, false, scormEnabled),
    renderCard: (isReadOnly: boolean) => (props: CardsViewerItem<any>) => (
      <StaticAssetCard isDraggable={!isReadOnly} item={{ ...props.item }} />
    ),
  },
  {
    label: "Events",
    id: "flow-designer-events-filter",
    permissions: [RolePermissions.EventsView],
    renderCard: (isReadOnly: boolean) => (props: CardsViewerItem<any>) => (
      <DesignerAssetCard
        dataHookType="flow-designer-event-card"
        isDraggable={!isReadOnly}
        assetType={EntityType.ExternalEvent}
        id={props.item.id}
        title={props.item.title}
        thumbnailUrl={props.item.thumbnailUrl}
        dragNDropItemType={props.item.dragNDropItemType}
        hasReminders={props.item.hasReminders}
        visibility={props.item.visibility}
        publisher={props.item.publisher}
      />
    ),
  },
  {
    label: "Communications",
    id: "flow-designer-emails-filter",
    permissions: [RolePermissions.CommunicationsView],
    renderCard: (isReadOnly: boolean) => (props: CardsViewerItem<any>) => {
      const assetType = {
        Email: EntityType.Email,
        Message: EntityType.Message,
      };

      const icons = {
        Email: <i className="big fa-envelope icon" />,
        Message: <i className="big fa-message icon" />,
      };

      return (
        <DesignerAssetCard
          isDraggable={!isReadOnly}
          dataHookType={"flow-designer-communication-card"}
          thumbnailUrl={icons[props.item.contentType as keyof typeof icons]}
          assetType={assetType[props.item.contentType as keyof typeof assetType]}
          id={props.item.id}
          title={props.item.title}
          dragNDropItemType={props.item.dragNDropItemType}
          publisher={props.item.publisher}
        />
      );
    },
    filterOptions: communicationsOptions,
  },
  {
    label: "Extras",
    id: "flow-designer-extras-filter",
    permissions: [RolePermissions.FlowsView],
    renderCard: (isReadOnly: boolean) => (props: CardsViewerItem<any>) => (
      <ExtrasCard isDraggable={!isReadOnly} item={{ ...props.item }} />
    ),
  },
];
